import React from 'react';

import styled from '@emotion/styled';

import StatusCell from '../../Badge/StatusCell';

interface VehicleListCellProps {
  data?: any;
  moreOptionsComponents?: React.ReactNode[];
}

const VehicleListCell: React.FC<VehicleListCellProps> = ({
  data,
  moreOptionsComponents,
}) => {
  return (
    <Container>
      <FirstRow>
        <FirstRowLeftItems>
          <FirstText> {data?.fleetPlateNumber ?? 'N/A'}</FirstText>
          {
            <StatusCell
              data={{ status: data?.status }}
              statusKey='status'
              customClasses='small-border-radius'
            />
          }
        </FirstRowLeftItems>
      </FirstRow>
      <SecondRow>
        <div>{data?.assignedDriver ?? 'N/A'} </div>
        <VerticalDivider />
        <div>{data?.type ?? 'N/A'}</div>
      </SecondRow>
    </Container>
  );
};

export default VehicleListCell;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  margin-bottom: 12px;
  font-size: 14px;
`;

const FirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: flex;
  position: relative;
  /* g */
`;

const FirstRowLeftItems = styled.div`
  gap: 12px;
  align-items: center;
  margin-right: 18px;
  display: grid;
  grid-auto-flow: column;
  overflow: auto;

  /* Hide scroll bar */
  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    white-space: nowrap;
  }
`;

const FirstText = styled.div`
  display: flex;
`;

const SecondRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
const VerticalDivider = styled.div`
  height: 14px;
  width: 1px;
  background-color: ${({ theme }) => theme.palette.borderColor};
`;
